'use client';

import { c as _c } from "react/compiler-runtime";
import '~/app/globals.css';
import * as React from 'react';
import { NAV_THEME } from '~/lib/theme';

// Web-only theme provider - simplified for Next.js
const LIGHT_THEME = {
  colors: NAV_THEME.light
};
const DARK_THEME = {
  colors: NAV_THEME.dark
};
export function ThemeProviderWrapper(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [, setMounted] = React.useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      document.documentElement.classList.add("bg-background");
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[2] !== children) {
    t3 = <div className={false ? "dark" : "light"}>{children}</div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}